export default __webpack_public_path__ + "static/media/elegant-logo.9202c01b.svg";